
export default {
  inject: ['inMenu', 'direction', 'close'],

  provide () {
    return {
      direction: 'block'
    };
  },

  props: {
    value: {
      type: [Boolean, Array],
      default: false
    },

    name: {
      type: null,
      default: undefined
    },

    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * @values icons
     */
    icon: {
      /** @type {AlturaIcons} */
      type: String,
      required: false,
      default: undefined
    },

    type: {
      type: String,
      validator: value => ['checkbox', 'normal', 'delete'].includes(value),
      default: 'normal'
    },

    label: {
      type: String,
      default: 'Action'
    },

    hideHotkey: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      hotkey: null
    };
  },

  computed: {
    hasSubmenu () {
      return !!this.$slots.default;
    },

    submenuAlign () {
      if (process.browser && window.matchMedia('only screen and (max-width: 800px)').matches) {
        return 'bottom';
      }

      if (this.direction === 'block') { return 'right-start'; }

      return 'bottom-start';
    }
  },

  mounted () {
    if (this.hasSubmenu && 'click' in this.$listeners) {
      throw new Error(
        "An menu-item with a submenu can't handle click events for usability reasons."
      );
    }
  },

  methods: {
    click (event) {
      if (this.disabled) { return; }

      if (!event) {
        event = {
          target: this.$el,
          preventDefault: () => {},
          keyEvent: true
        };
      }

      this.$emit('click', event);
      this.close();
    },

    clickhandler (event) {
      if (this.disabled) { return; }

      if (this.hasSubmenu) { event.stopImmediatePropagation(); } else if (this.type === 'checkbox') { this.$refs.checkbox.click(); } else { this.click(event); }
    },

    selectNext () {
      this.$el?.nextElementSibling?.focus();
    },

    selectPrevious () {
      if (this.$el.previousElementSibling) { this.$el?.previousElementSibling?.focus(); } else { this.closeMenu(); }
    },

    async toggleSubmenu (value, event) {
      if (!this.$refs.submenu) { return; }

      this.$refs.submenu.internalShow =
        value ?? !this.$refs.submenu.internalShow;

      if (!this.$refs.submenu.internalShow) {
        event.stopPropagation();
        this.$el.focus();
      } else {
        await this.$nextTick();

        this.$refs.submenu.$el.querySelector('.action')?.focus();
      }
    }
  }
};
